module.exports = __webpack_public_path__ + "img/icon_sx.0d58de67.png";